import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constants} from '../../common/constants';
import {FieldConfigName} from '../../../models';
import {ControlDialogOptionsHelper} from '../control-dialog-options-helper';

@Component({
  selector: 'app-text-area-dialog',
  templateUrl: './text-area-dialog.component.html',
})
export class TextAreaDialogComponent extends ControlDialogOptionsHelper implements OnInit {
  constants: any = Constants;
  editTextAreaForm: UntypedFormGroup;
  status: boolean;
  control: FieldConfigName;

  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<TextAreaDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data) {
      this.control = data.control || this.control;
    }
  }

  ngOnInit(): void {
    this.validateFormBuilder();
    this.editProperty(this.control);
  }

  validateFormBuilder(): void {
    this.editTextAreaForm = this.formBuilder.group({
      tooltip: ['', []],
      label: ['', []],
      placeholder: ['', []],
      isRequired: [false]
    });
  }

  editProperty(control: any): void {
    this.status = control.options.isRequired;
    this.editTextAreaForm.setValue({
      tooltip: control.options.tooltip,
      label: control.options.label,
      placeholder: control.options.placeholder,
      isRequired: control.options.isRequired
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.editTextAreaForm.invalid) {
      return;
    }
    this.dialogRef.close(this.editTextAreaForm.value);
  }
}
